import icon_1 from '../assets/icons/icon-1.png';
import icon_2 from '../assets/icons/icon-2.png';
import icon_3 from '../assets/icons/icon-3.png';
import icon_4 from '../assets/icons/icon-4.png';
// Offer Image
import offer_1 from '../assets/offer-1.png';
import offer_2 from '../assets/offer-2.png';

// Values Image
import value_1 from '../assets/icons/value-1.png';
import value_2 from '../assets/icons/value-2.png';
import value_3 from '../assets/icons/value-3.png';
// User image
import user from '../assets/user.png'
export const navLinks = [
    {
        id: 1,
        title: "Home",
        link: `/`
    },
    {
        id: 2,
        title: "Property Management",
        link: '/property'
    },
    {
        id: 3,
        title: "For Rent/Lease",
        link: `/rent`
    },
    {
        id: 4,
        title: "Property Listing",
        link: '/property-listing'
    },
    {
        id: 5,
        title: "About Us",
        link: `/about`
    },
    {
        id: 6,
        title: "Contact Us",
        link: '/contact'
    },
]


export const property = [
    {
        id: 1,
        title: "Property Management",
        icon: icon_3,
        link: '/property'
    },
    {
        id: 2,
        title: "Rent / Lease",
        icon: icon_2,
        link: '/rent'
    },
    {
        id: 3,
        title: "Property Listing",
        icon: icon_4,
        link: '/property-listing'
    },
    {
        id: 4,
        title: "Tenant Login",
        icon: icon_1,
        link: 'https://account.appfolio.com/realms/foliospace/protocol/openid-connect/auth?activation_state&client_id=client-e23cdaec-00a6-44fa-b236-533bbf975644&portfolio_uuid&redirect_uri=https%3A%2F%2Fmillenniumr.appfolio.com%2Fconnect%2Fusers%2Foauth%2Fcallback&response_type=code&scope=openid&session_timed_out=false&state=%2Fconnect%2F'
    },
    {
        id: 4,
        title: "Owner Login",
        icon: icon_3,
        link: 'https://millenniumr.appfolio.com/oportal/users/log_in'
    },
]

export const abouts = [
    {
        id: 1,
        title: "Happy Customers",
        number: "200+",
    },
    {
        id: 2,
        title: "Properties For Clients",
        number: "10K+",
    },
    {
        id: 3,
        title: "Years of Experience",
        number: "20+",
    },


]

export const offer = [
    {
        id: 2,
        title: "Expert Commercial Property Management",
        detail: "We apply targeted marketing, strong lease management, and proactive maintenance to minimize vacancies and improve tenant satisfaction.",
        point: [
            "Strategic property marketing and listing exposure",
            "Professional tenant selection and lease enforcement",
            "On-site maintenance coordination",
            "Transparent financial reporting",
            "Detailed occupancy and lease performance reporting"
        ],
        button: "Explore Commercial Solutions",
        img: offer_1,
    },
    {
        id: 1,
        title: "Professional Residential Property Management",
        detail: "We manage single-family homes, duplexes, condominiums, and multi-unit residential properties with personalized care and strategic oversight.",
        point: [
            "Thorough tenant screening and lease administration",
            "Online rent collection and account management",
            "Cost-effective maintenance and preventative care",
            "Transparent financial reporting"
        ],
        button: "Learn More About Residential Management",
        img: offer_2,
    },
    {
        id: 3,
        title: "Investment-Focused Property Management",
        detail: "We conduct ongoing market analysis, rental rate optimization, recommend income-enhancing property improvements, and handle all financial transactions.",
        point: [
            "Rental income optimization",
            "Market rent and vacancy analysis",
            "Budgeting and expense forecasting",
            "Monthly, accurate financial statements"
        ],
        button: "Maximize Your Investment",
        img: offer_1,
    },
    // {
    //     id: 4,
    //     title: "Comprehensive HOA Property Management",
    //     detail: "We support homeowners associations with structured governance, financial transparency, and proactive community maintenance solutions.",
    //     point: [
    //         "Board meeting coordination and documentation",
    //         "Dues collection and financial management",
    //         "Vendor supervision and contract negotiation",
    //         "Community compliance enforcement",
    //         "Detailed financial and reserve reporting"
    //     ],
    //     button: "Discover HOA Management Services",
    //     img: offer_1,
    // },
    // {
    //     id: 5,
    //     // title:"Short-Term & Vacation Rental Management",
    //     detail: "We handle every aspect of short-term rental operations, ensuring maximum occupancy, positive guest experiences, and optimized revenue performance.",
    //     point: [
    //         "Dynamic pricing and revenue strategy",
    //         "Professional listing creation and marketing",
    //         "Guest communication and support",
    //         "Housekeeping and property inspections",
    //         "Performance tracking and revenue reporting"
    //     ],
    //     button: "Optimize Your Short-Term Rental",
    //     img: offer_2,
    // },
    {
        id: 6,
        title: "Luxury Estate Property Management",
        detail: "We provide tailored management services for high-end estates, ensuring premium maintenance standards and personalized oversight.",
        point: [
            "White-glove tenant screening",
            "Concierge-level maintenance coordination",
            "Discreet financial management",
            "Comprehensive asset preservation strategies"
        ],
        button: "Elevate Your Luxury Property Management",
        img: offer_1,
    }
]


export const values = [
    {
        id: 1,
        title: "Integrity",
        detail: "Property owners trust us with significant investments, and we take that responsibility seriously by ensuring clear communication, accurate reporting, and full regulatory compliance at all times.",
        img: value_1
    },
    {
        id: 2,
        title: "Accountability",
        detail: "From maintenance coordination to financial oversight, every action we take is measurable and aligned with our clients’ objectives. Our team remains proactive, responsive, and solution-oriented in every situation.",
        img: value_2
    },
    {
        id: 3,
        title: "Expertise",
        detail: "We understand local regulations, tenant laws, and market trends — enabling us to deliver strategic guidance and strong financial performance.",
        img: value_3
    },
    {
        id: 4,
        title: "Commitment",
        detail: "Our goal is to consistently improve property value, maintain strong tenant relationships, and help property owners achieve sustainable growth over time.",
        img: value_1
    },
]



export const process = [
    {
        id: 1,
        title: "Initial Consultation",
        detail: "We begin by understanding your property, investment objectives, and any specific concerns. Our licensed experts evaluate the property’s condition, tenant history, and market potential."
    },
    {
        id: 2,
        title: "Property Assessment",
        detail: "Our team conducts a detailed inspection of the property, identifying maintenance needs, compliance issues, and opportunities to increase value. This ensures your investment is positioned for long-term success."
    },
    {
        id: 3,
        title: "Strategic Planningn",
        detail: "Based on our assessment, we develop a complete strategy covering marketing, tenant acquisition, lease agreements, maintenance schedules, and financial oversight all designed to maximize occupancy ."
    },
    {
        id: 4,
        title: "Marketing & Leasing",
        detail: "We promote your property across multiple channels, screen applicants thoroughly, and execute professional lease agreements. Our goal is to secure reliable tenants quickly and efficiently, reducing vacancies."
    },
    {
        id: 5,
        title: "Active Management",
        detail: "We handle daily operations including rent collection, maintenance coordination, tenant communication, and regulatory compliance. Our proactive approach keeps your property well-maintained and tenants satisfied."
    },
    {
        id: 6,
        title: "Reporting & Optimization",
        detail: "Monthly financial and performance reports keep you informed. We continuously analyze results, recommend improvements, and optimize strategies to protect your investment and maximize returns over time."
    },
]


export const testimonials = [
    {
        id: 1,
        name: "Sarah M.",
        city: "San Francisco",
        detail: "Millennium Realty has transformed my rental experience. From tenant screening to maintenance, every step is seamless. I finally feel confident that my property is in expert hands.",
        title: "Residential Success",
        img: user,
    },
    {
        id: 2,
        name: "James L.",
        city: "New York",
        detail: "The team at Millennium Realty is outstanding! Their attention to detail and prompt communication make managing my property stress-free.",
        title: "Smooth Property Management",
        img: user,
    },
    {
        id: 3,
        name: "Emily R.",
        city: "Los Angeles",
        detail: "I never thought renting out my apartment could be this easy. Millennium Realty handles everything professionally and efficiently.",
        title: "Hassle-Free Rentals",
        img: user,
    },
    {
        id: 4,
        name: "Michael S.",
        city: "Chicago",
        detail: "From marketing my property to managing tenants, Millennium Realty delivers excellence at every step. Highly recommended!",
        title: "Top-Notch Service",
        img: user,
    },
    {
        id: 5,
        name: "Olivia K.",
        city: "Miami",
        detail: "I’m impressed with Millennium Realty’s dedication and expertise. They make property management simple and worry-free.",
        title: "Professional & Reliable",
        img: user,
    },
    {
        id: 6,
        name: "Daniel P.",
        city: "Seattle",
        detail: "Millennium Realty’s team is knowledgeable and responsive. My property is always in great hands, and the tenants are happy too.",
        title: "Exceptional Experience",
        img: user,
    },
];

export const faq = [
    {
        id: 1,
        question: "What types of properties do you manage?",
        answer: "We manage residential homes, multi-unit buildings, commercial office spaces, retail centers, and mixed-use properties throughout the San Francisco & Bay Area."
    },
    {
        id: 2,
        question: "How is property maintenance handled?",
        answer: "We coordinate routine and emergency maintenance through trusted vendors, track all requests, and proactively maintain properties."
    },
    {
        id: 3,
        question: "How are your management fees structured?",
        answer: "Our fees are transparent and typically based on a percentage of monthly rent collected. We provide detailed contracts outlining all services included."
    },

]
